export const environment = {
  production: true,
  RH_BASE_URL: "https://impacto-api.nativatools.com",
  APP_BASE_URL: "https://impacto-app.nativatools.com",
  SPACESHIP_APP_BASE_URL: "https://spaceship-app.nativatools.com"
};
